import PriceDetails from '@/components/elements/PriceDetails';
import CartCrossSellModalWrapper from '@/components/modal/CartCrossSellModalWrapper';
import CompanyUSPModalWrapper from '@/components/modal/CompanyUSPModalWrapper';
import HeroContentModalWrapper from '@/components/modal/HeroContentModalWrapper';
import InventoryModalWrapper from '@/components/modal/InventoryModalWrapper';
import CrossSellModalWrapper from '@/components/modal/CrossSellModalWrapper';
import CrossSellInterstitialWrapper from '@/components/modal/CrossSellInterstitialWrapper';
import BenefitModalWrapper from '@/components/modal/BenefitModalWrapper';
import SecondarySelectorModalWrapper from '@/components/modal/SecondarySelectorModalWrapper';
import RadioSelectorModalWrapper from '@/components/modal/RadioSelectorModalWrapper';
import BundleOfferModalWrapper from '@/components/modal/BundleOfferModalWrapper';
import AddressChangeModal from '@/components/modal/addressChangeModal/AddressChangeModal';
import UtilityNavModalWrapper from '@/components/modal/UtilityNavModalWrapper';

/**
 * Configuration for all the modals used in the modal provider. The keys here
 * are important and should not be changed lightly because their names are sent
 * to heap for tracking purposes.
 *
 * Add new modals here and it will be available globally via the modal provider.
 * (Use next/dynamic for a lighter bundle if a little delay is acceptable.)
 */
export const MODAL_CONFIGS = {
  priceDetails: {
    Component: PriceDetails,
    closeButton: { variant: 'basic', strokeColor: '#000000' }
  },
  cartCrossSell: {
    Component: CartCrossSellModalWrapper,
    closeButton: { variant: 'basic', strokeColor: '#FFFFFF' }
  },
  companyUSP: {
    Component: CompanyUSPModalWrapper,
    closeButton: { variant: 'basic', strokeColor: '#000000' }
  },
  utilityNav: {
    Component: UtilityNavModalWrapper,
    closeButton: { variant: 'basic', strokeColor: '#000000' }
  },
  heroContent: {
    Component: HeroContentModalWrapper,
    closeButton: { variant: 'basic', strokeColor: '#000000' }
  },
  inventory: {
    Component: InventoryModalWrapper,
    closeButton: { variant: 'enhanced', strokeColor: '#FFFFFF' }
  },
  crossSell: {
    Component: CrossSellModalWrapper,
    closeButton: { variant: 'enhanced', strokeColor: '#FFFFFF' }
  },
  crossSellInterstitial: {
    Component: CrossSellInterstitialWrapper,
    closeButton: { variant: 'basic', strokeColor: '#FFFFFF' },
    handlesEscapeKey: true
  },
  benefit: {
    Component: BenefitModalWrapper,
    closeButton: { variant: 'basic', strokeColor: '#000000' }
  },
  secondarySelector: {
    Component: SecondarySelectorModalWrapper,
    closeButton: { variant: 'basic', strokeColor: '#000000' }
  },
  variantHelp: {
    Component: RadioSelectorModalWrapper,
    closeButton: { variant: 'basic', strokeColor: '#000000' }
  },
  bundleOffer: {
    Component: BundleOfferModalWrapper,
    closeButton: { variant: 'basic', strokeColor: '#FFFFFF' }
  },
  addressChange: {
    Component: AddressChangeModal,
    closeButton: { variant: 'basic', strokeColor: '#000000' }
  }
};
